export default __webpack_public_path__ + "assets/numbrz_icon.png";